/**
 * Header sidebar accordion reset.
 *
 * When the drawer closes, the theme collapses the menu by removing the "open" attribute only, which leaves
 * aria-expanded="true" behind on the details element. The chevron would stay rotated and the first click after
 * reopening the drawer would be swallowed, so both states are kept in sync here.
 */
(() => {
  const SIDEBAR_ID = 'sidebar-menu';

  function collapseAll(sidebar) {
    sidebar.querySelectorAll('details').forEach((details) => {
      details.open = false;
      details.setAttribute('aria-expanded', 'false');
      details.style.height = '';
      details.style.overflow = '';
    });
  }

  function attach() {
    const sidebar = document.getElementById(SIDEBAR_ID);

    if (!sidebar || sidebar.dataset.accordionResetBound === 'true') return;

    sidebar.dataset.accordionResetBound = 'true';
    sidebar.addEventListener('dialog:after-hide', () => collapseAll(sidebar));
  }

  attach();

  // The header is re-rendered on every setting change in the theme editor.
  document.addEventListener('shopify:section:load', attach);
})();
